export const isValidExtension = (fileName?: string): boolean => {
    if (fileName) {
        const fileParts = fileName.split('.');
        if (fileParts.length > 1) {
            const potentialExtension = fileParts.pop();
            if (potentialExtension && /^[a-zA-Z]+$/.test(potentialExtension))
                return potentialExtension === 'pdf';
        }
    }

    return true;
}
